import { useAuth0 } from "@auth0/auth0-react";
import Grid from '@material-ui/core/Grid';
import PreSchoolService from 'Lib/API/PreSchool/index';
import EditSvgComponent from 'assets/icons/svg/Edit/index';
import FormGeneratorComponent from 'components/FormGenerator/FormGenerator';
import { useDisableEnterKey } from "hook";
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { formatDateInFormData, sanitizeItems } from 'utils/formDataHelper';
import { Files, FormContant, FormEditButton, FormSection, FormTitleSection, FormWrapper } from './Theme';

export const FormViwer = ({ participantId, formData, handleDownload, onUpdateFormParticipant }) => {
	const { getAccessTokenSilently } = useAuth0();
	const [fieldsData, setFieldsData] = useState({ data: [], values: [] });
	const [enableEdit, setEnableEdit] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [resetKey, setResetKey] = useState(0);
	const originalValues = useRef([]);
	const schemaRef = useRef([]);

	useEffect(() => {
		const filterAnswerFormData = formData?.formData?.map((item) => {
			const checkBoxesOption = item?.name?.includes("checkboxes") || item?.name?.includes("radiobuttons");
			if (checkBoxesOption) {
				const checkboxesValues = (Array.isArray(item?.value) ? item.value : []).map((value) => {
					const lastIndexOfUnderLine = value?.lastIndexOf("_");
					return value.substring(0, lastIndexOfUnderLine);
				});
				return { ...item, value: checkboxesValues };
			}
			return { ...item, value: item?.value || "" };
		});
		const schema = formatDateInFormData(formData?.class?.form?.task_data) || [];
		originalValues.current = filterAnswerFormData || [];
		schemaRef.current = schema;
		setFieldsData({
			data: schema,
			values: JSON.parse(JSON.stringify(filterAnswerFormData || [])),
		});
	}, []);

	const validate = (submittedData) => {
		const errors = {};
		const validatedLabels = ['first name', 'last name', 'birth date'];
		const schema = formData?.class?.form?.task_data || schemaRef.current || [];
		schema.forEach((schemaField) => {
			if (!schemaField.required) return;
			if (!validatedLabels.includes(schemaField.label?.toLowerCase()?.trim())) return;
			const submitted = submittedData.find(
				(d) => d.id === schemaField.id || d.name === schemaField.field_name
			);
			const isEmpty =
				!submitted ||
				submitted.value === undefined ||
				submitted.value === null ||
				(Array.isArray(submitted.value) ? submitted.value.length === 0 : String(submitted.value).trim() === '');
			if (isEmpty) {
				errors[schemaField.id] = `${schemaField.label || 'This field'} is required`;
			}
		});
		return errors;
	};

	const handleCancel = () => {
		setFieldsData(prev => ({
			...prev,
			values: JSON.parse(JSON.stringify(originalValues.current)),
		}));
		setResetKey(k => k + 1);
		setEnableEdit(false);
	};

	const onUpdateFormHandler = async (data) => {
		const errors = validate(data);
		if (Object.keys(errors).length > 0) {
			toastr.error('Validation', Object.values(errors).join(', '));
			return;
		}
		const filterAnswerFormData = data?.map((item) => {
			const checkBoxesOption = item?.name?.includes("checkboxes") || item?.name?.includes("radiobuttons");
			if (checkBoxesOption) {
				return { ...item, value: (Array.isArray(item?.value) ? item.value : []).map((v) => `${v}_0`) };
			}
			return { ...item };
		});
		setIsLoading(true);
		const token = await getAccessTokenSilently();
		PreSchoolService.updateParticipant(token, { formData: filterAnswerFormData }, participantId)
			.then(() => {
				toastr.success('Success', 'Participant updated successfully!');
				onUpdateFormParticipant();
			})
			.catch((error) => {
				toastr.error(error?.data?.message || 'Something went wrong!');
			})
			.finally(() => setIsLoading(false));
	};

	useDisableEnterKey(true);

	return (
		<FormWrapper className="view-form-wrapper">
			<FormSection style={{ background: "#fff", marginTop: "15px" }}>
				{!enableEdit && (
					<FormEditButton onClick={() => setEnableEdit(true)}>
						<EditSvgComponent />
					</FormEditButton>
				)}
				<FormContant>
					<div>
						{((fieldsData?.values?.length || enableEdit) || formData?.data?.length) && (
							<FormGeneratorComponent
								key={resetKey}
								answerData={fieldsData?.values || []}
								formData={sanitizeItems(fieldsData?.data) || []}
								enableEdit={enableEdit}
								setEnableEdit={setEnableEdit}
								onUpdateForm={onUpdateFormHandler}
								isLoading={isLoading}
								onCancel={handleCancel}
							/>
						)}
						<hr />
						<div className="files__container">
							<div className="files__title">{`Files(${formData?.files?.length})`}</div>
							<Files>
								{formData?.files.map((file, index) => (
									<li key={index} onClick={() => handleDownload(file)}>file {index + 1}</li>
								))}
							</Files>
						</div>
					</div>
				</FormContant>
			</FormSection>
		</FormWrapper>
	);
};
